import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

import { createRoute } from 'lib/util';

const GroupsEditToggle = ({ company, subcompany, group, t }) => (
  <Form.Link
    className="btn btn-outline-primary btn-sm mx-2"
    to={createRoute(company.id, subcompany.id, `groups/${group.id}/edit`)}
  >
    {t('actions.edit')}
  </Form.Link>
);

export default translate()(GroupsEditToggle);



// WEBPACK FOOTER //
// src/modules/secured/modules/groups/components/list/actions/GroupsActionsEdit.js